// src/api/generalActivityLogApi.js
import apiClient from "./axios";

const generalActivityLogApi = {
  /**
   * Fetch general activity logs (system-wide, not resource-specific like ticket/leave)
   * @param {Object} params - Query parameters
   * @returns {Promise<Object>} API response data
   */
  getAll: async (params = {}) => {
    const {
      page = 1,
      page_size = 10,
      search = "",
      // You can easily add more filters later if backend supports them
      // resource_type,
      // causer_id,
      // event,
      // start_date,
      // end_date,
    } = params;

    try {
      const response = await apiClient.get("/activity-logs", {
        params: {
          page,
          page_size,
          search: search.trim() || undefined,
          // add more params here when needed
        },
      });
      return response.data;
    } catch (err) {
      throw err; // let thunk handle rejection
    }
  },

  // Optional: if you implement single log detail fetch
  getById: async (id) => {
    const response = await apiClient.get(`/activity-logs/${id}`);
    return response.data;
  },
};

export default generalActivityLogApi;